import React, { Fragment } from 'react';

// import { Container } from './styles';

function StateView({
  error,
  empty,
  loading,
  children,
  viewEmpty,
  viewError,
  viewLoading,
}) {
  if (loading) {
    return <Fragment>{viewLoading}</Fragment>;
  }

  if (!!error && !!viewError) {
    return <Fragment>{viewError}</Fragment>;
  }

  if (!!empty && !!viewEmpty) {
    return <Fragment>{viewEmpty}</Fragment>;
  }

  return <Fragment>{children}</Fragment>;
}

export default StateView;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/ui/StateView/index.js